import React from "react";
import { HiBars3, HiUser } from "react-icons/hi2";
import { getCookie } from "../../../utils/cookieUtils";
import "./style.css";
import { Link } from "react-router-dom";

const AdminHeader = (props) => {
  const username = getCookie("X-Spl-Username-Header");
  return (
    <div style={{ backgroundColor: "#000E54", padding: "14px 16px" }}>
      <div className="textall">
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="speech_HB">{"Speech App"}</div>
        </Link>

        <div className="helps drpdown uicons">
            Welcome {username} !
          <button className="drpbtn"><HiUser /></button>
          <div className="drpdown-content">
            <a href="#">Switch to User</a>
            <a href="#">Logout</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
